import type { CheckoutPaymentSchedule } from '@afterpaytouch/portal-api'

export interface SchedulePreviewEntry {
  schedule: CheckoutPaymentSchedule
  installmentIndex: number
}

export const getSchedulePreview = (schedules: CheckoutPaymentSchedule[]): SchedulePreviewEntry[] => {
  if (!Array.isArray(schedules) || schedules.length === 0) {
    return []
  }

  if (schedules.length === 1) {
    return [{ schedule: schedules[0], installmentIndex: 0 }]
  }

  return [
    { schedule: schedules[0], installmentIndex: 0 },
    { schedule: schedules[schedules.length - 1], installmentIndex: schedules.length - 1 },
  ]
}
